import { ButtonScaleViewOpts } from 'src/lib/ui/components/ButtonScaleView';
import { AssetGroup } from '@play-co/timestep-core';
import { FeatureButton } from '../../components/FeatureButton';
import i18n from 'src/lib/i18n/i18n';
import { isHomeShortcutAvailable } from '../homeShortcut.utils';
import { spineLoader } from '@play-co/timestep-spine';

const assets = {
  spine: {
    loadMethod: spineLoader,
    url: 'assets/ui/homeShortcut/button/home_button',
  },
  label: 'assets/ui/homeShortcut/button/label-bg.png',
};

export class homeShortcutButtonAnimated extends FeatureButton {
  constructor(opts: ButtonScaleViewOpts) {
    super({
      width: 144,
      height: 180,
      pressedOffsetY: 5,
      labelPanel: {
        width: 133,
        height: 44,
        localeText: () => i18n('homeShortcut.button'),
        offsetX: 3,
        labelOffsetY: -4,
        font: 'Title',
        fontSize: 17,
        background: {
          image: assets.label,
        },
      },
      ...opts,
    });

    this.animationStateMap = {
      main: {
        type: 'spine',
        assetGroup: new AssetGroup(Object.values(assets)),
        url: assets.spine.url,
        scale: 0.67,
        offsetX: 1,
        offsetY: 85,
        sequence: ['idle'],
      },
    };
  }

  public update() {
    if (!isHomeShortcutAvailable()) {
      this.hide();
      return;
    }

    this.show();
    this.setAnimationState('main');
  }
}
